export default "__VITE_ASSET__BMqEMNe5__"